import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Cleave from 'cleave.js/react';
import { Input, ZipForm, Textarea, AlertNotice } from 'shared/components';
import JsxParser from 'react-jsx-parser';
import { Link } from 'react-router-dom';
import './RegisterProfile.scss';

const ADDRESS_MAX_LENGTH = 36;
const dateDelimiter = '          |   ';

class RegisterProfile extends Component {
  constructor(props) {
    super(props);

    this.onDateChange = this.onDateChange.bind(this);
    this.handleZipChange = this.handleZipChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onPinChange = this.onPinChange.bind(this);
    this.handleWorkPhoneExtChange = this.handleWorkPhoneExtChange.bind(this);
  }

  onDateChange(e) {
    if (e.target.rawValue.toString().length < 8) {
      return;
    }
    const dateString = e.target.value.split(dateDelimiter).join('-');
    this.props.onChange({ user: { birthDate: dateString } });
  }

  onPhoneChange(e) {
    this.props.onChange({
      user: { [e.target.name]: e.target.rawValue },
    });
  }

  onPinChange(e) {
    this.props.onChange({
      user: {
        pin: e.target.rawValue,
      },
    });
  }

  handleZipChange(zipData, name, value, error) {
    this.props.onChange({ user: zipData }, name, value, error);
  }

  handleWorkPhoneExtChange(e) {
    if (e.target.value.length > 8) {
      return;
    }
    this.props.onChange(e);
  }

  render() {
    const { user, errors, serverError } = this.props;

    return (
      <section className="register-profile">
        <h4 className="page-title">{this.props.t('register.personalInformationTitle')}</h4>
        {!user.id && <p>{this.props.t('register.personalInformationMessage')}</p>}
        <form className="list-group list-group-flush" noValidate>
          <div className="list-group-item name-form-container">
            <Input
              type="text"
              name="lastName"
              id="UserProfileLastName"
              label="forms.labels.lastName"
              value={user.lastName}
              onChange={this.props.onChange}
              errors={errors.lastName}
              required
            />
            <Input
              type="text"
              name="firstName"
              id="UserProfileFirstName"
              value={user.firstName}
              label="forms.labels.firstName"
              onChange={this.props.onChange}
              errors={errors.firstName}
              required
            />
          </div>
          <div className="list-group-item">
            <div className="input-container w-100">
              <Textarea
                label={this.props.t('forms.labels.address')}
                name="address1"
                rows={3}
                value={user.address1}
                onChange={this.props.onChange}
                error={errors.address1}
                maxLength={ADDRESS_MAX_LENGTH}
                required
              />
            </div>
          </div>

          <ZipForm address={user} handleChange={this.handleZipChange} errors={errors} />
          <div className="list-group-item">
            <div className="input-container w-75">
              <label
                htmlFor="UserProfileCellPhone"
                className={`${errors.cellPhone ? 'label-error' : ''} fw-bold`}>
                {this.props.t('forms.labels.cellPhone')} ({this.props.t('common.labels.optional')})
              </label>
              <Cleave
                className={errors.cellPhone ? 'error' : ''}
                name="cellPhone"
                id="UserProfileCellPhone"
                options={{
                  phone: true,
                  phoneRegionCode: 'US',
                  delimiter: '-',
                }}
                value={user.cellPhone}
                onChange={this.onPhoneChange}
                errors={errors.cellPhone}
                required
              />
              {errors.cellPhone &&
                errors.cellPhone.map((error) => (
                  <span className="text-error font-size-12" key={error}>
                    {this.props.t(error)}
                  </span>
                ))}
            </div>
          </div>
          <div className="list-group-item work-phone-group">
            <div className="input-container w-75">
              <label
                htmlFor="UserProfileWorkPhone"
                className={`${errors.workPhone ? 'label-error' : ''} fw-bold`}>
                {this.props.t('forms.labels.workPhone')}
              </label>
              <Cleave
                name="workPhone"
                className={errors.workPhone ? 'error' : ''}
                id="UserProfileWorkPhone"
                options={{
                  phone: true,
                  phoneRegionCode: 'US',
                  delimiter: '-',
                }}
                value={user.workPhone}
                onChange={this.onPhoneChange}
                errors={errors.workPhone}
                required
              />
              {errors.workPhone &&
                errors.workPhone.map((error) => (
                  <span className="text-error font-size-12" key={error}>
                    {this.props.t(error)}
                  </span>
                ))}
            </div>
            <Input
              containerClassName="phone-extension-container"
              type="text"
              name="workPhoneExt"
              value={user.workPhoneExt}
              label="common.labels.extension"
              onChange={this.handleWorkPhoneExtChange}
              infoText={this.props.t('register.optionalLabel')}
              errors={errors.workPhoneExt}
            />
          </div>
          {this.props.reviewInfo ? (
            <div>
              <div className="list-group-item">
                <Input
                  size="w-100"
                  type="text"
                  name="emailAddress"
                  id="UserProfileEmail"
                  value={user.emailAddress}
                  onChange={this.props.onChange}
                  label="common.labels.email"
                  disabled
                  required
                />
              </div>
              <JsxParser
                className="pb-3"
                bindings={{
                  link: {
                    pathname: `/email-us`,
                    state: {
                      preselectedSubject: 'Email address change',
                    },
                  },
                }}
                components={{ Link }}
                jsx={this.props.t('register.personalInformationUpdateMessage')}
              />
              {serverError && (
                <AlertNotice message={this.props.t('errors.serverError')} type="error" />
              )}
              <div className="buttons-container bottom-container">
                <button type="button" onClick={this.props.onCancel} className="btn w-50">
                  {this.props.t('common.labels.back')}
                </button>
                <button
                  type="submit"
                  className="btn btn-primary w-50 "
                  onClick={this.props.onSubmit}>
                  {this.props.t('common.labels.continue')}
                </button>
              </div>
            </div>
          ) : (
            <div className="bottom-container">
              {serverError && (
                <AlertNotice message={this.props.t('errors.serverError')} type="error" />
              )}
              <button
                type="submit"
                className="btn btn-primary m-0 w-100"
                onClick={this.props.onSubmit}>
                {this.props.t('common.labels.continue')}
              </button>
            </div>
          )}
        </form>
      </section>
    );
  }
}

RegisterProfile.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  errors: PropTypes.shape({}),
  reviewInfo: PropTypes.bool,
  onCancel: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

RegisterProfile.defaultProps = {
  errors: {},
  reviewInfo: false,
  onCancel: undefined,
};

export default withTranslation()(RegisterProfile);
